import moment from "moment-timezone";

const LEGACY_LOCALE = "en-GB";
const LEGACY_TZ = "America/Argentina/Buenos_Aires";

/**
 * Misma cadena que `pages/_components/FormattedDate.jsx`.
 * @param {string|number|Date|null|undefined} input
 * @param {boolean} [showTime=true] — equivalente a `FormattedDate` `showTime`
 * @returns {string}
 */
export default function formatLegacyWebDateTimeString(input, showTime = true) {
    if (input === undefined || input === null || input === "") {
        return "";
    }
    const dateToParse = moment(input).format();
    const d = new Date(dateToParse);
    if (Number.isNaN(d.getTime())) {
        return String(input);
    }
    const full = d.toLocaleString(LEGACY_LOCALE, { timeZone: LEGACY_TZ });
    const datePart = full.slice(0, Math.max(0, full.length - 10));
    if (!showTime) {
        return datePart.trim();
    }
    const timePart = d.toLocaleTimeString(LEGACY_LOCALE, { timeZone: LEGACY_TZ });
    return `${datePart} ${timePart}`.trim();
}
